<template>
  <v-container>
      <h1 class="text text-h4 titulo mb-6">
        <v-icon class="mr-2" large>event_available</v-icon>Calendario de Compromisos [Mts<sup>2</sup>]
      </h1>
      <div class="d-flex justify-end mb-2">
        <v-chip small label color="info">Comprometido</v-chip>
        <v-chip small label color="green" dark>Terminado</v-chip>
        <v-chip small label color="error">Pendiente</v-chip>
      </div>
        <div>
          <v-sheet
            tile
            height="54"
            class="d-flex align-center"
          >
            <v-btn
              icon
              class="ma-2"
              @click="$refs.calendar.prev()"
              :disabled="loading"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <div class="text text-h6 titulo">{{currentMonth}}</div>
            <v-spacer></v-spacer>
            <v-btn
              icon
              class="ma-2"
              @click="$refs.calendar.next()"
              :disabled="loading"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-sheet>
          <v-sheet height="600">
              <v-progress-linear
                color="primary"
                indeterminate
                rounded
                height="6"
                v-show="loading"
              ></v-progress-linear>
            <v-calendar
              v-show="!loading"
              ref="calendar"
              v-model="value"
              :weekdays="weekday"
              :type="type"
              :event-height="25"
              :events="events"
              :event-more="false"
              :event-overlap-mode="mode"
              :event-overlap-threshold="100"
              :event-color="getEventColor"
              @change="changeinCalendar"
              @click:event="showEvent"
              
            ></v-calendar>
            <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
            >
            <v-card
              min-width="350px"
              flat
              style="opacity:1"
            >
              <v-toolbar dense :color="selectedEvent.color" class="justify-space-around">
                  <div v-if="selectedEvent.type=='all'" class="text white--text text-h6 mr-2">Comprometido</div>
                  <div v-else-if="selectedEvent.type=='completed'" class="text white--text text-h6 mr-2">Terminado</div>
                  <div v-else class="text white--text text-h6 mr-2">Pendiente</div>
                  <div class="text white--text text-h6">{{selectedEvent.start | moment('DD/MM/YYYY')}}</div>
              </v-toolbar>
              <v-list>
                <div v-if="selectedEvent.type=='all'">
                  <v-list-item v-for="workOrder in selectedEvent.workOrders" :key="workOrder.id">
                    <show-work-order :work_order_id="workOrder.id">
                      <div class="d-flex">
                        <div class="text mr-2">OT {{workOrder.id}} - {{workOrder.name}}</div>
                        <div class="text"><strong :class="`${selectedEvent.color}--text`">{{workOrder.total_mts2 | number('0,0.00')}}</strong> Mts<sup>2</sup></div>
                      </div>
                    </show-work-order>
                  </v-list-item>
                </div>
                <div v-else-if="selectedEvent.type=='completed'">
                  <div v-for="workOrder in selectedEvent.workOrders" :key="workOrder.id">
                    <v-list-item v-if="workOrder.completed_mts2>0">
                      <show-work-order :work_order_id="workOrder.id">
                        <div class="d-flex">
                          <div class="text mr-2">OT {{workOrder.id}} {{workOrder.name}}</div>
                          <div class="text"><strong :class="`${selectedEvent.color}--text`">{{workOrder.completed_mts2 | number('0,0.00')}}</strong> Mts<sup>2</sup></div>
                        </div>
                      </show-work-order>
                    </v-list-item>
                  </div>
                </div>
                <div v-else>
                  <div v-for="workOrder in selectedEvent.workOrders" :key="workOrder.id">
                    <v-list-item>
                      <show-work-order :work_order_id="workOrder.id">
                        <div class="d-flex">
                          <div class="text mr-2">OT {{workOrder.id}} - {{workOrder.name}}</div>
                          <div class="text"><strong :class="`${selectedEvent.color}--text`">{{workOrder.total_mts2-workOrder.completed_mts2 | number('0,0.00')}}</strong> Mts<sup>2</sup></div>
                        </div>
                      </show-work-order>
                    </v-list-item>
                  </div>
                </div>
                <v-list-item>
                  Total: <span class="ml-2" ><strong :class="`${selectedEvent.color}--text`">{{selectedEvent.value | number('0,0.00')}}</strong> Mts<sup>2</sup></span> 
                </v-list-item>
              </v-list>  
                
            </v-card>
          </v-menu>
          </v-sheet>
        </div>
        <v-dialog  v-model='display' max-width="1200">
          <v-card class="pa-4" >
            <work-order-card :work_order='workOrderOnDisplay' @close="display=false" :loading="workOrderOnDisplayLoading"/> 
          </v-card>
        </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment'
import numeral from 'numeral'
import {fetchWorkOrders} from '@/api/production'
import notifications from '@/utils/notifications'
export default {
  name:'CompromiseCalendar',
  data() {
    return {
      currentMonth: '',
      workOrders:[],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      type: 'month',
      types: ['month', 'week', 'day', '4day'],
      mode: 'stack',
      modes: ['stack', 'column'],
      weekday: [1, 2, 3, 4, 5,6,0],
      weekdays: [
        { text: 'Lunes - Domingo', value: [1, 2, 3, 4, 5, 6, 0] },
        { text: 'Lunes - Viernes', value: [1, 2, 3, 4, 5] },
      ],
      value: '',
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1','orange darken-4'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      workOrderOnDisplay:{},
      workOrderOnDisplayLoading:false,
      display:false,
      loading:false,
    }
  },
  methods:{
      getEventColor (event) {
        return event.color
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      async changeinCalendar(event){
        this.events=[]
        this.currentMonth=moment(event.start.date).format('MMMM').toUpperCase()+' - '+event.start.year
        this.loading=true
        //Aplicando restricción para vendedor
        var filterSeller=''
        if (!this.$can('realAll', 'SalesNote')){
          const user = this.$store.getters.getUser
          filterSeller=user.id
        }
        if(this.$can('read','WorkOrder')){
          filterSeller=''
        }
        await fetchWorkOrders(1,-1,'','','',event.start.date,event.end.date,'',filterSeller)
        .then((data)=>{
          this.workOrders = data.results
          this.workOrders.forEach(wO=>{
            wO.stringDeliveryDate=moment(wO.delivery_date).format('YYYY-MM-DD')
          })

          //Agrupo por día
          const groupByDay = this.workOrders.reduce((acc, value) =>{
            if (!acc[value.stringDeliveryDate]) {
              acc[value.stringDeliveryDate] = [];
            }
            acc[value.stringDeliveryDate].push(value);
            return acc;
            }, {});


            Object.keys(groupByDay).map(day=>{
              var start = ''
              var totalMts2=0
              var totalMts2Completed=0
          
              groupByDay[day].map(wO=>{
                //Calculo total de Mts2
                totalMts2+=parseFloat(wO.total_mts2)
                start = new Date(wO.delivery_date)
                wO.completed_mts2=0

                wO.products.filter(p=>p.completed).forEach(p=>{ wO.completed_mts2+=parseFloat(p.mts2)})
                totalMts2Completed+=wO.completed_mts2
              })
              this.events.push({
                name:`${numeral(totalMts2).format('0,0[.]0')}`,
                value: totalMts2,
                start:start,
                color:'info',
                workOrders:groupByDay[day],
                type:'all'
              })
              this.events.push({
                name:`${numeral(totalMts2Completed).format('0,0[.]0')}`,
                value: totalMts2Completed,
                start:start,
                color:'green',
                workOrders:groupByDay[day],
                type:'completed',
                alignment:'center'
              })
              this.events.push({
                name:`${numeral(totalMts2-totalMts2Completed).format('0,0[.]0')}`,
                value: totalMts2-totalMts2Completed,
                start:start,
                color:'error',
                workOrders:groupByDay[day].filter(wO=>!wO.completed),
                type:'pending'
              })
              
            })
        })
        .catch(error=>{
          notifications.showError(error)
        })
        .finally(()=>{
          this.loading=false
        })
      }
  },
  async created(){
    
    
  }
}
</script>

<style  lang="scss">
.v-event{
  font-size:15px !important;
  height:20px !important;
}
.v-past{
  background-color: lightgrey !important;
}
.v-calendar-weekly__day-label{
  .v-btn{
    height: 20px !important;
  }
}

</style>